export const DEFAULT_NATIONALITY = 'CN';
export const DEFAULT_TRAVEL_DOC_TYPES = ['passport', 'id'];
export const AIRLINE_PROFILES = ['dotrez', 'kiwi'];
